import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { CATEGORY_NAME } from 'graphql/queries';
import { useTranslation } from 'next-i18next';

const mapQueryCategories = data => {

  const categoryData = data?.categoryList[0];

  const parentCategory = {
    name: categoryData?.name,
    path: categoryData?.url_key
  };

  const breadcrumbs = categoryData?.breadcrumbs?.map(crumb => {
    return {
      name: crumb.category_name,
      path: crumb.category_url_key
    };
  });

  const categories = [parentCategory, breadcrumbs];

  const queryCategories = categories.flat().filter(category => category);

  return queryCategories;
};

const mapBreadcrumbs = (data, pathname, t) => {
  
  if (data.length > 0) {
    data.push(data.shift());

    const crumbs = data.map(crumb => {
      const crumbLength =
        pathname.lastIndexOf(crumb.path) + crumb?.path?.length;

      const name = crumb.name;
      const path = pathname.substring(0, crumbLength);

      return { name, path };
    });

    const breadcrumbs = [{ name: t('ui.home'), path: '/' }, ...crumbs];

    return breadcrumbs;
  } else return null;
};

export default function useBreadcrumbs() {
  const { t } = useTranslation();

  const router = useRouter();

  const [queryCrumbs, setQueryCrumbs] = useState([]);
  const [crumbs, setCrumbs] = useState([]);

  const { kategooria: categories } = router.query;

  const query = categories?.slice().pop();

  const { data } = useQuery(CATEGORY_NAME, {
    variables: { name: query },
    context: { fetchOptions: { method: 'GET' } }
  });

  useEffect(() => {
    if (data) {
      const queryCategories = mapQueryCategories(data);
      if (queryCategories) setQueryCrumbs(queryCategories);
    }
  }, [data?.categoryList]);

  useEffect(() => {
    const path = router.asPath;

    const crumbs = mapBreadcrumbs(queryCrumbs, path, t);
    if (crumbs) setCrumbs(crumbs);
  }, [queryCrumbs]);

  return crumbs;
}
